// add the "read more" link to the bottom of lengthy tap descriptions
if ($(document).width() > 768) {
    $('.tap').each(function () {
        let heading = $(this).find('.taps-list-item-details-heading');
        let details = $(this).find('.taps-list-item-details-secondary');
        let body = $(this).find('.taps-list-item-details-description');

        if ((heading.height() + details.height() + body.height()) > 240) {
            let tag = $('<div>')
                .addClass('read-more-footer')
                .append(
                    $('<a>')
                        .attr('href', '#')
                        .attr('data-toggle', 'modal')
                        .attr('data-target', '#tap-modal')
                        .text('Read More')
                );
            $(this).find('.taps-list-item-details').append(tag);
        }
    });
}

$('#tap-modal').on('show.bs.modal', function (e) {
    let modal = $(this);
    let button = $(e.relatedTarget);
    let tap = button.closest('.tap');

    let name = tap.find('.taps-list-item-details-name').text();
    let tapNumber = tap.find('.taps-list-item-details-tap-number').text();
    modal.find('.tap-modal-title').text(`${tapNumber} ${name}`);

    let description = tap.find('.taps-list-item-details-description').text().trim();
    modal.find('.tap-modal-description').text(description);
});
